import React, { Fragment, useState } from 'react';
import $ from 'jquery';

import AuthorAvatar from './page/AuthorAvatar';
import TettraEditor from '../tettra-editor/components/TettraEditor';
import AnswerQuestionDropDown from './questions/AnswerQuestionDropDown';

import createEmptyEditorState from '../tettra-editor/utilities/createEmptyEditorState';
import editorStateToRawContent from '../tettra-editor/utilities/editorStateToRawContent';
import editorStateToHTML from '../tettra-editor/utilities/editorStateToHTML';

import { KEYCODE } from '../tettra-editor/utilities/CONSTANTS';
import { EVENTS, ERROR } from '../utilities/CONSTANTS';

import { canMarkAnswer } from '../utilities/permissionsUtilities';

const getConfig = (isAnswerComment) => ({
    editorIdentifier: isAnswerComment ? 'AnswerCommentInput' : 'CommentInput',
    commentEditor: true,
    readOnly: false,
    spellCheck: true,
    enableAutosave: false,
    enableTables: false,
    enableInsertControls: false,
    enableMentionSuggestions: true,
    enableInternalSuggestions: true,
    enableExternalSuggestions: !!isAnswerComment,
    enableExternalFocus: true,
    enableImageUpload: true,
    enableFileUpload: false,
    enableSmallEditor: true,
    enableChoosePageDialog: !!isAnswerComment,
    textPlaceholder: 'Reply...',
});

let hideCommentActionButtonLatch = true;

const CommentInput = (props) => {
    const [editorState, setEditorState] = useState(createEmptyEditorState());
    const [isUploading, setUploading] = useState(null);
    const selectionState = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const showAnswerButtons = props.isAnswerComment && canMarkAnswer();
    const disableReply = !contentState.getPlainText().trim();

    if (selectionState.getHasFocus() && hideCommentActionButtonLatch) {
        hideCommentActionButtonLatch = false;
    }

    const onSubmitComment = () => {
        if (isUploading) {
            alert(ERROR.IS_UPLOADING);
            return;
        }

        if (disableReply) return;

        const content_state = JSON.stringify(editorStateToRawContent(editorState));
        const html = editorStateToHTML(editorState);

        props.submitComment({ content_state, html })
            .then(({ success }) => {
                if (success) {
                    setEditorState(createEmptyEditorState());
                }
            });
    };

    const onButtonKeyDown = (e) => {
        if ((e.keyCode == KEYCODE.space || e.keyCode == KEYCODE.enter)) {
            onSubmitComment();
        }
    };

    const onKeyDown = (e) => {
        if ((e.metaKey || e.ctrlKey) && e.keyCode == KEYCODE.enter) {
            onSubmitComment();
        }
    };

    const onSubmitCommentAndAnswer = () => {
        if (isUploading) {
            alert(ERROR.IS_UPLOADING);
            return;
        }

        if (disableReply) return;

        const content_state = JSON.stringify(editorStateToRawContent(editorState));
        const html = editorStateToHTML(editorState);

        props.submitCommentAndAnswer({ content_state, html })
            .then(({ success }) => {
                if (success) {
                    setEditorState(createEmptyEditorState());
                }
            });
    };

    const buttonClass = (isUploading || disableReply) ? 'is-disabled' : '';
    const containerClass = hideCommentActionButtonLatch ? 'hide' : '';

    const onClickPostComment = (e) => {
        if ($(e.target).is('.post-comment')) {
            window.dispatchEvent(new Event(EVENTS.FOCUS_EDITOR));
        }
    };

    if (props.isSubmitting) {
        return null;
    }

    return (
        <div className="post-comment print-hide" onMouseDown={onClickPostComment}>
            <div className="flex-none">
                <AuthorAvatar userId={window.userId} tooltip="Commenting as you" customClass="post-comment-avatar left" noLink />
            </div>
            <div className="post-comment-content" onKeyDown={onKeyDown}>
                <TettraEditor
                    config={getConfig(props.isAnswerComment)}
                    editorState={editorState}
                    updateModel={setEditorState}
                    setUploading={setUploading}
                />
                <div className={`${containerClass} mt2`}>
                    {showAnswerButtons && <AnswerQuestionDropDown questionId={props.questionId} />}
                    <div className="comment-actions right">
                        {showAnswerButtons
                        && (
                            <button
                                id="comment-submit-and-answer"
                                role="button"
                                className={`btn-secondary mr1 mt2 ${buttonClass}`}
                                onMouseDown={onSubmitCommentAndAnswer}
                            >
                            Reply and mark as answer
                            </button>
                        )}
                        <button
                            id="comment-submit"
                            role="button"
                            className={`submit-comment-button ${buttonClass}`}
                            onKeyDown={onButtonKeyDown}
                            onMouseDown={onSubmitComment}
                        >
                            Reply
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentInput;
